module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_job_banner_variant5_image-a8122f2c5c007cc42eaf08cac847654d.jpg";